export default new class Common {
    constructor() {

    }

    /**
     * changes declension of word depending on the value of number
     *
     * @param number - declension based on this number
     * @param titles - array of words "[0// Яблок, 1// Яблоко, 2// Яблока]"
     * @returns {*} word in correct declension
     */
    declensionOfNum(number, titles) {
        let cases = [2, 0, 1, 1, 1, 2];

        return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
    }
};



// WEBPACK FOOTER //
// ./src/common/assets/js/common.js